export default {
  baseURL: process.env.REACT_APP_API_HOST || 'https://localhost:5001',
}
